export const LAYOUT_ALGORITHM = {
    HIERARCHIC: 1,
    ORGANIC: 2,
    ORTHOGONAL: 3,
    CIRCULAR: 4,
    TREE: 5
};
